import { theme, $fontJakarta } from '../../styles/theme';

export const authPageLeftPanelContainer = {
  alignItems: 'start',
  justifyContent: 'center',
  height: '100%',
  minHeight: '100%'
};

export const authPageLeftPanelIllustrationWrapper = {
  position: 'relative',
  width: '346px',
  height: '322px',
  marginRight: '50px',
  alignSelf: 'flex-end'
};

export const authPageLeftPanelWhiteCard = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '265px',
  height: '209px',
  backgroundColor: 'white',
  borderRadius: '24px'
};

export const authPageLeftPanelHeader = {
  fontWeight: 700,
  color: theme.palette.common.brandPrimary40,
  fontSize: '72px',
  lineHeight: '80px',
  letterSpacing: 0,
  marginTop: '24px'
};

export const authPageLeftPanelDescription = {
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '24px',
  marginTop: '24px',
  color: theme.palette.common.white
};

export const authPageLeftPanelImg = {
  position: 'absolute',
  top: '32px',
  right: 0,
  width: '290px',
  height: '290px',
  zIndex: 1
};

export const authPageLeftPanelTextContent = {
  margin: '-6rem 0 0 0',
  fontFamily: $fontJakarta
};
